import useOcCompanies from "./use-companies";
import { useOcProperty } from "./use-property";
import getCorrectBase64Image from "oc/utils/get-correct-base64-image";

const useOcDefaultCompanyLogo = () => {
  const { data, error } = useOcCompanies();
  const { data: selectedCompanyCode } = useOcProperty({
    resource: "system",
    key: "selectedCompany",
  });

  let companies = data?.companies?.rows;
  let companyLogo = null;
  let companyName = null;

  if (companies?.length > 0) {
    // Try to find the selected company by code
    let selectedCompany = null;
    if (selectedCompanyCode) {
      selectedCompany = companies.find(
        (company: any) => company.code === selectedCompanyCode
      );
    }

    // Fallback to first company if no selection or not found
    const company = selectedCompany || companies[0];

    let rawLogo = company.companyLogo;
    if (rawLogo) {
      companyLogo = getCorrectBase64Image(rawLogo);
    }
    companyName = company.name;
  }

  return { companyLogo: companyLogo, companyName: companyName, error };
};

export default useOcDefaultCompanyLogo;
